import { Component, ChangeDetectionStrategy, input, output } from '@angular/core';

// Chips under an aiMode assistant reply, from MessageEx.clCompChat_quickReplies (see
// classes/ai-quick-replies.ts), plus the optional aiConfig.handoff chip. Labels are model output:
// they're only ever rendered as text via p-button's [label], never [innerHTML]. ChatComponent
// decides which message shows them (the last one, once it has finished streaming), sends a chosen
// label as an ordinary user turn and turns a handoff click into onAiHandoffRequested.
@Component({
  selector: 'app-ai-quick-replies',
  templateUrl: './ai-quick-replies.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class AiQuickRepliesComponent {
  options = input<string[]>([]);
  handoffLabel = input<string | undefined>(undefined);
  disabled = input<boolean>(false);

  selected = output<string>();
  handoff = output<void>();
}
